import { useMemo, useEffect } from 'react';
import { filterData } from './filterData';
import { useSearchParams } from 'react-router-dom';
import { eventData } from './constants.ts';
import { useFilterStore } from '../state/useFilterStore';
import type { Filters, FilterKey } from '../types/FiltersSchema';

export function useFiltering() {
  const {
    data,
    searchValue,
    filters,
    setFilters,
    setData,
    setSearchValue,
    clearFilters,
  } = useFilterStore();
  const [, setSearchParams] = useSearchParams();

  useMemo(() => {
    setData(
      filterData({
        data: eventData,
        filters,
        searchValue,
      }),
    );
  }, [filters, searchValue, setData]);

  // update search params when filters change
  useEffect(() => {
    // Filter out empty string values from filters
    // and add search value to filters
    const activeFilters = Object.entries({ ...filters, s: searchValue }).reduce(
      (acc, [key, value]) => {
        if (value !== '') {
          acc[key as FilterKey] = value;
        }
        return acc;
      },
      {} as Filters,
    );

    setSearchParams(activeFilters);
  }, [filters, setSearchParams, searchValue]);

  return {
    data,
    searchValue,
    setSearchValue,
    filters,
    setFilters,
    setData,
    clearFilters,
  };
}
